import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from '../../../../../../../core/layout/services/loading.service';
import * as moment from 'moment/moment';
import { ModalAlertComponent } from '../../../../modals/modal-alert/modal-alert.component';
import { InvestmentDetailsDto } from '@wlp/ui-bs-cashout/lib/dto/investment-details.dto';

@Component({
  selector: 'app-historical-movements',
  templateUrl: './historical-movements.page.html',
  styleUrls: ['./historical-movements.page.scss'],
})
export class HistoricalMovementPage implements OnInit {


  @Input()
  public extractInvestmentData: InvestmentDetailsDto

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  paginatedMovements: any[] = [];

  currentPage = 1;
  itemsPerPage = 10;


  constructor(
    public loadingService: LoadingService,
    protected userInfoService: UserInfoService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
  ) {
  }

  public ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    
    if (this.extractInvestmentData.movements.length > 0) {
      this.setPage(this.currentPage);
    } else {
      this.paginatedMovements = [];
    }
  }

  setPage(page: number) {
    const start = (page - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedMovements = this.extractInvestmentData.movements.slice(start, end);
    this.currentPage = page;
  }

}
